import { createElement, useEffect, useState, useRef, Fragment } from 'react';
import DocumentPortal from 'react-document-portal';
import useKeypress from 'react-use-keypress';

function SvgClose() {
  return /*#__PURE__*/createElement("svg", {
    height: 35,
    width: 50
  }, /*#__PURE__*/createElement("path", {
    d: "M0 0h50v10c0 13.798-11.202 25-25 25S0 23.798 0 10z",
    fill: "#415b58"
  }), /*#__PURE__*/createElement("g", {
    fill: "none",
    opacity: 0.5,
    stroke: "#fff",
    strokeLinecap: "round"
  }, /*#__PURE__*/createElement("path", {
    d: "M21 5l8 8M29 5l-8 8"
  })), /*#__PURE__*/createElement("g", {
    fill: "#fff",
    fillOpacity: 0.5
  }, /*#__PURE__*/createElement("path", {
    d: "M14.928 20.028c-.18-.234-.408-.414-.684-.54s-.561-.189-.855-.189a2.247 2.247 0 00-1.724.756c-.207.234-.367.509-.481.824s-.171.652-.171 1.012c0 .336.054.654.162.954s.264.564.468.792.453.408.747.54.627.198.999.198c.366 0 .687-.075.963-.225s.51-.36.702-.63l.729.549c-.048.066-.132.161-.252.284s-.279.246-.477.369-.437.231-.716.324-.601.139-.967.139c-.504 0-.959-.096-1.364-.288s-.75-.444-1.035-.756-.502-.664-.652-1.057-.225-.791-.225-1.193c0-.492.081-.946.243-1.363s.388-.777.679-1.08.641-.539 1.049-.707.858-.252 1.35-.252c.42 0 .832.081 1.237.243s.737.411.995.747zM16.737 18.651h.864v5.562h2.925v.81h-3.789zM24.243 25.185c-.486 0-.933-.085-1.341-.256a3.126 3.126 0 01-1.733-1.769c-.165-.408-.247-.849-.247-1.323s.082-.915.247-1.323.393-.762.684-1.062.641-.535 1.049-.706.855-.257 1.341-.257.933.086 1.341.257.757.406 1.048.706.519.654.684 1.062.248.849.248 1.323-.083.915-.248 1.323-.393.762-.684 1.062-.64.536-1.048.707-.855.256-1.341.256zm0-.81c.366 0 .696-.067.99-.202s.546-.317.756-.545.372-.496.486-.805.171-.638.171-.986-.057-.676-.171-.985-.276-.578-.486-.806-.462-.409-.756-.544-.624-.203-.99-.203-.696.068-.99.203-.546.316-.756.544-.372.497-.486.806-.171.637-.171.985.057.677.171.986.276.577.486.805.462.41.756.545.624.202.99.202zM28.905 23.691c.156.234.355.407.598.518s.494.166.752.166c.144 0 .291-.022.441-.067s.287-.113.41-.203c.122-.09.223-.201.301-.333s.117-.285.117-.459c0-.246-.078-.433-.234-.562s-.349-.237-.58-.324c-.232-.087-.483-.171-.756-.252s-.525-.194-.756-.338-.425-.337-.581-.58-.234-.572-.234-.986c0-.186.041-.384.122-.594s.208-.402.382-.576.398-.319.671-.436.601-.176.985-.176c.348 0 .681.048.999.144s.597.291.837.585l-.702.639c-.108-.168-.261-.303-.459-.405s-.423-.153-.675-.153c-.24 0-.439.032-.598.095s-.287.144-.383.243-.163.205-.203.319a1.006 1.006 0 00-.058.315c0 .27.078.477.234.621s.349.261.58.351c.232.09.483.171.756.243s.526.173.756.302c.232.129.425.303.581.522s.234.52.234.904a1.852 1.852 0 01-.648 1.449c-.198.168-.432.297-.702.387s-.558.135-.864.135c-.408 0-.795-.072-1.161-.216s-.657-.366-.873-.666zM33.63 18.651h4.113v.81h-3.249v1.899h3.024v.81h-3.024v2.043h3.411v.81H33.63z"
  })));
}

function SvgSpinner() {
  return /*#__PURE__*/createElement("svg", {
    height: 40,
    width: 40
  }, /*#__PURE__*/createElement("g", {
    fillOpacity: 0.75
  }, /*#__PURE__*/createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 20 20",
    to: "360 20 20",
    dur: "1.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/createElement("circle", {
    cx: 20,
    cy: 5,
    r: 5
  }), /*#__PURE__*/createElement("circle", {
    cx: 20,
    cy: 35,
    r: 5
  }), /*#__PURE__*/createElement("circle", {
    cx: 9,
    cy: 31,
    r: 5
  }), /*#__PURE__*/createElement("circle", {
    cx: 31,
    cy: 31,
    r: 5
  }), /*#__PURE__*/createElement("circle", {
    cx: 35,
    cy: 20,
    r: 5
  }), /*#__PURE__*/createElement("circle", {
    cx: 5,
    cy: 20,
    r: 5
  }), /*#__PURE__*/createElement("circle", {
    cx: 9,
    cy: 9,
    r: 5
  }), /*#__PURE__*/createElement("circle", {
    cx: 31,
    cy: 9,
    r: 5
  })));
}

var useLockBodyScroll = function useLockBodyScroll() {
  useEffect(function () {
    var overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.overflow = overflow;
    };
  }, []);
};

var Modal = function Modal(props) {
  var onRequestClose = props.onRequestClose;

  var _useState = useState(true),
      isLoading = _useState[0],
      setLoading = _useState[1];

  useKeypress('Escape', onRequestClose);
  useLockBodyScroll();
  return /*#__PURE__*/createElement(DocumentPortal, null, /*#__PURE__*/createElement("div", {
    "aria-modal": "true",
    role: "dialog",
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 99999,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      overflow: 'auto'
    }
  }, /*#__PURE__*/createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      width: 310
    }
  }, isLoading && /*#__PURE__*/createElement("div", {
    "aria-label": "Loading",
    style: {
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 420,
      width: 310,
      background: 'linear-gradient(180deg, #2d3a38 0%, #415b58 100%)'
    }
  }, /*#__PURE__*/createElement(SvgSpinner, null)), /*#__PURE__*/createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      opacity: 0.98
    }
  }, /*#__PURE__*/createElement("iframe", {
    "aria-label": "The Shielded Site",
    frameBorder: "0",
    height: "420",
    onLoad: function onLoad() {
      setLoading(false);
    },
    ref: function ref(node) {
      node == null ? void 0 : node.focus();
    },
    sandbox: "allow-forms allow-scripts allow-same-origin allow-popups",
    src: "https://staticcdn.co.nz",
    width: "310"
  }), /*#__PURE__*/createElement("button", {
    "aria-label": "Close",
    type: "button",
    onClick: onRequestClose,
    style: {
      display: 'inline-block',
      alignSelf: 'center',
      margin: '-1px 0 0 0',
      padding: 0,
      border: 'none',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      appearance: 'none',
      background: 'none',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/createElement(SvgClose, null))))));
};

if (process.env.NODE_ENV !== 'production') {
  Modal.propTypes = {
    onRequestClose: function onRequestClose() {}
  };
}

function SvgButton() {
  return /*#__PURE__*/createElement("svg", {
    height: 32,
    viewBox: "0 0 192 192",
    width: 32
  }, /*#__PURE__*/createElement("circle", {
    cx: 96,
    cy: 96,
    fill: "#445e5c",
    r: 96
  }), /*#__PURE__*/createElement("circle", {
    cx: 96,
    cy: 95,
    fill: "#fff",
    r: 87
  }), /*#__PURE__*/createElement("path", {
    d: "M96 11a84 84 0 000 168z",
    fill: "#445e5c"
  }), /*#__PURE__*/createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/createElement("path", {
    d: "M96 50.5H48a2.5 2.5 0 00-2.5 2.5v70a2.5 2.5 0 002.5 2.5h48",
    strokeDasharray: 6
  }), /*#__PURE__*/createElement("path", {
    d: "M99.76 135.5h-43a2 2 0 00-1.76 1.11l-4 8a2 2 0 00.08 1.94c.37.6 1 .95 3.71.95h44.79",
    strokeDasharray: "7 6"
  })), /*#__PURE__*/createElement("g", {
    fill: "none",
    stroke: "#445e5c"
  }, /*#__PURE__*/createElement("path", {
    d: "M96 52h47a1 1 0 011 1v70a1 1 0 01-1 1H96",
    strokeWidth: 6
  }), /*#__PURE__*/createElement("path", {
    d: "M96 135.5h39a2 2 0 011.79 1.11l4 8a2 2 0 01-1.79 2.89H96",
    strokeWidth: 3
  }), /*#__PURE__*/createElement("path", {
    d: "M96 141h43m-37-5v5m8.5-5l.5 5m8-5l1 5m7-5l4 11",
    strokeWidth: 2
  })));
}

var Shielded = function Shielded() {
  var buttonRef = useRef(null); // Set to `null` initially to prevent calling focus on first mount.

  var _useState = useState(null),
      isOpen = _useState[0],
      setOpen = _useState[1];

  useEffect(function () {
    if (isOpen === false) {
      var _buttonRef$current;

      (_buttonRef$current = buttonRef.current) == null ? void 0 : _buttonRef$current.focus();
    }
  }, [isOpen]);
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("button", {
    "aria-label": "Women\u2019s Refuge",
    onClick: function onClick() {
      setOpen(true);
    },
    ref: buttonRef,
    style: {
      display: 'inline-block',
      margin: 0,
      padding: 0,
      border: 'none',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      appearance: 'none',
      background: 'none',
      cursor: 'pointer',
      opacity: isOpen ? 0 : 1
    },
    type: "button"
  }, /*#__PURE__*/createElement(SvgButton, null)), isOpen && /*#__PURE__*/createElement(Modal, {
    onRequestClose: function onRequestClose() {
      setOpen(false);
    }
  }));
};

if (process.env.NODE_ENV !== 'production') {
  Shielded.propTypes = {};
}

export default Shielded;
